import React from 'react';
import { LegalLayout } from '../components/Layout';
export const SupportPolicyPage = () => <LegalLayout title="Support Policy" lastUpdated="January 2026" data-id="element-761">
    <div className="space-y-8" data-id="element-762">
      <p className="text-gray-300 leading-relaxed" data-id="element-763">
        KDX provides customer support for:
      </p>

      <section data-id="element-764">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-765">Support Services</h2>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-766">
          <li data-id="element-767">Transaction issues</li>
          <li data-id="element-768">Wallet inquiries</li>
          <li data-id="element-769">Refund requests</li>
          <li data-id="element-770">Account access</li>
        </ul>
      </section>

      <section data-id="element-771">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-772">Response Time</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-773">
          Support requests are handled within a reasonable timeframe.
        </p>
      </section>

      <section data-id="element-774">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-775">Escalation</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-776">
          Unresolved issues may be escalated internally.
        </p>
      </section>
    </div>
  </LegalLayout>;